export default "__VITE_ASSET__CDxaVRmr__"